import EddyAiBanner from './EddyAiBannerContainer';

export default EddyAiBanner;
